/// <reference types="@angular/localize" />

console.log('main.ts is being executed');

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes'; // Ensure this path is correct
import { provideHttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // This is fine
import { importProvidersFrom } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { environment } from './environments/environment';
import { BidiModule, Directionality } from '@angular/cdk/bidi';
import { Subject } from 'rxjs';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  console.log('HttpLoaderFactory is being called');
  console.log(
    'HttpLoaderFactory path:',
    `${environment.frontEndUrl}/assests/i18n/ar.json`,
  );
  return new TranslateHttpLoader(
    http,
    `${environment.frontEndUrl}/assets/i18n/`,
    '.json',
  );
}

bootstrapApplication(AppComponent, {
  providers: [
    {
      provide: Directionality,
      useFactory: () => ({
        value: document.documentElement.dir as 'ltr' | 'rtl',
        change: new Subject<'ltr' | 'rtl'>(),
      }),
    },
    importProvidersFrom(BidiModule),
    provideRouter(routes), // Add the routes provider
    provideHttpClient(),
    importProvidersFrom(BrowserAnimationsModule), // This is OK
    importProvidersFrom(
      BrowserAnimationsModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
  ],
}).catch((err) => console.error(err));
